import React, { useState, useCallback, useMemo, useEffect } from "react";
import { motion } from "framer-motion";
import Loader from "../../components/Loader/Loader";
import {
  FetchAllPermissions,
  FetchEmployeePermissions,
  RegEmployeeService,
} from "../../services/apiService";
import { ToastContainer } from "react-toastify";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { User2Icon } from "lucide-react";

function RegEmployee() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    user_id: "",
    company_name: "",
    name: "",
    email_address: "",
    mobile_number: "",
    password: "",
    pin: "",
    pin_code: "",
    landmark_address: "",
    post_office: "",
    district: "",
    state: "",
    dob: "",
    aadhar_number: "",
    pan_number: "",
  });
  const [errors, setErrors] = useState({});
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [allAdminRoutes, setAllAdminRoutes] = useState({});
  // const [allAdminRoutes, setAdminMenus] = useState(null)

  const [group, setGroup] = useState([
    {
      name: "Dashboard",
      routePath: "admin-dashboard",
    },
    {
      apiUser: {
        subMenu: [
          {
            name: "Api Account",
            routePath: "ApiAccount",
          },
          { name: "API User KYC", routePath: "ApiUserKyc" },
          {
            name: "Api Approve Kyc",
            routePath: "ApiApproveKyc",
          },
          {
            name: "Wallet Balance Management",
            routePath: "Wallet_balance_management",
          },
          {
            name: "Billing Master",
            routePath: "BillingMaster",
          },
          {
            name: "Generate Quotation",
            routePath: "GenerateQuotation",
          },
          {
            name: "wallet transaction report",
            routePath: "wallet-transaction-report",
          },
          {
            name: "Commission Master",
            routePath: "CommissionMaster",
          },
          {
            name: "Fund Approve",
            routePath: "FundApprove",
          },
        ],
      },
    },

    { name: "Action For Approve", routePath: "ActionForApprove" },

    {
      name: "Generate Merchant Token",
      routePath: "GenerateMerchantToken",
    },
    {
      name: "SignUp Report",
      routePath: "SignUpReport",
    },
    {
      name: "Partner Report",
      routePath: "PartnerReport",
    },
    { name: "Service List", routePath: "ServiceList" },
    { name: "News", routePath: "News" },
    {
      ManageCollections: {
        subMenu: [
          {
            name: "Idfc Van Config",
            routePath: "IdfcVanConfig",
          },
          {
            name: "Idf Van Report",
            routePath: "IdfcVanReport",
          },
          {
            name: "Providers Report",
            routePath: "ProvidersReport",
          },
        ],
      },
    },

    {
      name: "Ifsc Master",
      routePath: "IfscMaster",
    },
    {
      name: "Document Master",
      routePath: "DocumentMaster",
    },
    {
      name: "Consent Master",
      routePath: "ConsentMaster",
    },
    {
      name: "Vendor Master",
      routePath: "VendorMaster",
    },
    {
      employeeMaster: {
        subMenu: [
          { name: "Reg Employee", routePath: "RegEmployee" },
          { name: "Reg Employee Report", routePath: "RegEmployeeReport" },
        ],
      },
    },

    {
      name: "Mobile Device Lock Report",
      routePath: "MobileDeviceLockReport",
    },
    {
      reports: {
        subMenu: [
          { name: "Assigned Report", routePath: "AssignedReport" },
          { name: "Payout Report", routePath: "PayoutReport" },
          { name: "Customer Report", routePath: "CustomerReport" },
          { name: "Api Service Report", routePath: "ApiServiceReport" },
          {
            name: "Service Usage Report",
            routePath: "ServiceUsageReport",
          },
          { name: "Revenue Report", routePath: "RevenueReport" },
          { name: "Api Key Report", routePath: "ApiKeyReport" },
        ],
      },
    },
    {
      services: {
        subMenu: [
          { name: "Add Service", routePath: "AddService" },
          {
            name: "Active Service Report",
            routePath: "ActiveServiceReport",
          },
          { name: "Activate Service", routePath: "ActivateService" },
          {
            name: "Activate Service Bulk",
            routePath: "ActivateServiceBulk",
          },
        ],
      },
    },
    {
      partnerShip: {
        subMenu: [
          { name: "Partnership", routePath: "PartnerShip" },
          { name: "Lead Report", routePath: "LeadReport" },
        ],
      },
    },
    {
      Email: {
        subMenu: [
          { name: "Send Email", routePath: "SendEmail" },
          { name: "Email Config", routePath: "EmailConfig" },
          { name: "Template Master", routePath: "TemplateMaster" },
        ],
      },
    },

    { name: "Manage Permission", routePath: "ManagePermission" },
    { name: "Check Permissions", routePath: "CheckPermissions" },

    {
      name: "Product List",
      routePath: "ProductList",
    },
    {
      name: "Product News",
      routePath: "ProductNews",
    },
    {
      name: "Banner",
      routePath: "Banner",
    },
    {
      name: "Master Training",
      routePath: "MasterTraining",
    },
    {
      name: "Master Page",
      routePath: "MasterPage",
    },
    {
      name: "Route List",
      routePath: "RouteList",
    },
    {
      name: "Profile",
      routePath: "Profile",
    },
  ]);

  const [userData, setUserData] = useState(null);

  // Menu to URL mapping - memoized to prevent recreation
  // const adminMenu = useMemo(
  //   () => ({
  //     "Admin Dashboard": "/dashboard",
  //     "Activate Service": "/activate-service",
  //     "Active Service Report": "/active-service-report",
  //     "Activate Service Bulk": "/ActivateServiceBulk",
  //     "Add Service": "/add-service",
  //     "Action For Approve": "/action-approve",
  //     "Document Master": "/DocumentMaster",
  //     "Consent master": "/ConsentMaster",
  //     "Api Approve Kyc": "/api-approve-kyc",
  //     "Api User Kyc": "/api-user-kyc",
  //     "Payout Report": "/payout-report",
  //     "Signup Report": "/SignUpReport",
  //     "Customer Report": "/customer-report",
  //     "Api Key Report": "/api-key-report",
  //     "Idfc Van Config": "/idfc-van-config",
  //     "Service Usage report": "/ServiceUsageReport",
  //     "Revenue Report": "/RevenueReport",
  //     "Vendor Master": "/VendorMaster",
  //     "Api Service Report": "/ApiServiceReport",
  //     "Mobile Device Lock Report": "/MobileDeviceLockReport",
  //     "Assigned Report": "/AssignedReport",
  //     "Idfc van  Report": "/IdfcVanReport",
  //     "Idfc Van Report": "/idfc-van-report",
  //     "Providers Report": "/providers-report",
  //     "Api Account": "/api-account",
  //     "Master Page": "/master-page",
  //     News: "/news",
  //     Banner: "/banner",
  //     "Product List": "/product-list",
  //     "Product News": "/product-news",
  //     Partnership: "/partnership",
  //     "Master Training": "/master-training",
  //     "Route List": "/route-list",
  //     Profile: "/profile",
  //     "Lead Report": "/lead-report",
  //     "Wallet Balance Management": "/wallet-balance-management",
  //     "Wallet Transaction Report": "/wallet-transaction-report",
  //     "Commission Master": "/commission-master",
  //     "Manage Permission": "/manage-permission",
  //     "Reg Employee": "/reg-employee",
  //     "Reg Employee Report": "/RegEmployeeReport",
  //     "Generate Merchant Token": "/GenerateMerchantToken",
  //     "Bulk Email": "/BulkEmail",
  //     "Check Permissions": "/CheckPermissions",
  //     "Fund Approve": "/fund-approve",
  //   }),
  //   [],
  // );

  // Reset form function
  const resetForm = useCallback(() => {
    setFormData({
      user_id: "",
      name: "",
      email_address: "",
      mobile_number: "",
      password: "",
      pin: "",
      pin_code: "",
      landmark_address: "",
      post_office: "",
      district: "",
      state: "",
      dob: "",
      aadhar_number: "",
      pan_number: "",
    });
    setSelectedPermissions([]);
    setErrors({});
  }, []);

  // const handleCopy = (text) => {
  //   navigator.clipboard.writeText(text);

  //   showSuccessToast("Copied ")
  // };

  // Handle input change with optimization
  const handleChange = useCallback(
    (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));

      // Clear error when user types
      if (errors[name]) {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    },
    [errors],
  );

  // Handle permission change with optimization
  const handlePermissionChange = useCallback((menu) => {
    setSelectedPermissions((prev) =>
      prev.includes(menu)
        ? prev.filter((item) => item !== menu)
        : [...prev, menu],
    );
  }, []);

  const handleGroupPermisssionChange = useCallback((subMenu) => {
    setSelectedPermissions((prev) => {
      const routes = subMenu.map((obj) => obj.routePath);

      const allSelected = routes.every((route) => prev.includes(route));

      if (allSelected) {
        // remove all submenu permissions
        return prev.filter((p) => !routes.includes(p));
      } else {
        // add missing submenu permissions
        return [...new Set([...prev, ...routes])];
      }
    });
  }, []);

  // Validation function
  const validate = useCallback(() => {
    const newErrors = {};

    // Required fields
    if (!formData.user_id.trim()) {
      newErrors.user_id = "User Id is required.";
    }
    if (!formData.company_name.trim()) {
      newErrors.company_name = "Company Name is required.";
    }
    if (!formData.name.trim()) {
      newErrors.name = "Employee Name is required.";
    }

    if (!formData.email_address.trim()) {
      newErrors.email_address = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email_address)) {
      newErrors.email_address = "Enter a valid email address.";
    }

    if (!formData.mobile_number.trim()) {
      newErrors.mobile_number = "Mobile Number is required.";
    } else if (!/^\d{10}$/.test(formData.mobile_number)) {
      newErrors.mobile_number = "Enter a valid 10-digit Mobile Number.";
    }

    if (!formData.password) {
      newErrors.password = "Password is required.";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters.";
    }

    // Optional field validations
    if (formData.aadhar_number && !/^\d{12}$/.test(formData.aadhar_number)) {
      newErrors.aadhar_number = "Aadhar must be exactly 12 digits.";
    }

    if (
      formData.pan_number &&
      !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.pan_number.toUpperCase())
    ) {
      newErrors.pan_number = "Invalid PAN format (e.g., ABCDE1234F).";
    }

    if (formData.pin && !/^\d{6}$/.test(formData.pin)) {
      newErrors.pin = "PIN must be 6 digits.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [formData]);

  // Handle Submit
  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      if (!validate()) {
        showErrorToast("Please fix the validation errors.");
        return;
      }

      if (selectedPermissions.length === 0) {
        showErrorToast("Please select at least one permission.");
        return;
      }

      setLoading(true);

      try {
        // Prepare permissions array
        const permissions = selectedPermissions.map((menu) => ({
          url: allAdminRoutes[menu],
          status: true,
        }));

        // Prepare payload
        const payload = {
          user: {
            user_id: formData.user_id,
            brand_name: formData?.company_name,
            name: formData.name.trim(),
            email_address: formData.email_address.trim(),
            mobile_number: formData.mobile_number.trim(),
            password: formData.password,
            ...(formData.pin && { pin: formData.pin }),
            ...(formData.pin_code && { pin_code: formData.pin_code.trim() }),
            ...(formData.landmark_address && {
              landmark_address: formData.landmark_address.trim(),
            }),
            ...(formData.post_office && {
              post_office: formData.post_office.trim(),
            }),
            ...(formData.district && { district: formData.district.trim() }),
            ...(formData.state && { state: formData.state.trim() }),
            ...(formData.dob && { dob: formData.dob }),
            ...(formData.aadhar_number && {
              aadhar_number: formData.aadhar_number,
            }),
            ...(formData.pan_number && {
              pan_number: formData.pan_number.toUpperCase(),
            }),
          },
          permissions: permissions,
        };

        // Call API service
        const response = await RegEmployeeService(payload);
        console.log("payload", payload);

        if (
          response &&
          (response.status === 200 ||
            response.status === 201 ||
            response.status?.code === 200 ||
            response?.data?.status?.code === 200)
        ) {
          showSuccessToast("Employee registered successfully!");
          console.log(response);

          setUserData(response || response.data || response.data?.data || {});
          resetForm();
        } else {
          const errorMessage =
            response?.data?.message ||
            response?.message ||
            response?.data?.status?.message?.["user.mobile_number"][0] ||
            response?.data?.status?.message?.["user.email_address"][0] ||
            response?.data?.status?.message?.["user.aadhar_number"][0] ||
            response?.data?.status?.message?.["user.pan_number"][0] ||
            response?.data?.status?.message?.["user.user_id"][0] ||
            "Registration failed. Please try again.";
          showErrorToast(errorMessage);
          console.log(response);
        }
      } catch (error) {
        console.error("Registration error:", error);
        showErrorToast(
          "An error occurred during registration. Please try again.",
        );
      } finally {
        setLoading(false);
      }
    },
    [validate, selectedPermissions, formData, allAdminRoutes, resetForm],
  );

  const fetchPermissions = async () => {
    try {
      const res = await FetchAllPermissions();

      if (res) {
        setAllAdminRoutes(
          res?.data?.permissions.reduce(
            (acc, { route_path }) => ({
              ...acc,
              [route_path]: route_path,
            }),
            {},
          ),
        );

        for (let index = 0; index < res?.data?.permissions.length; index++) {}
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchPermissions();
  }, []);

  useEffect(() => {
    console.log("selected permissions", selectedPermissions);
    console.log("all ADmin Routes", allAdminRoutes);
  }, [selectedPermissions, allAdminRoutes]);

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="p-6"
    >
      {loading && <Loader />}

      <div className="flex justify-center mt-6">
        <h2 className="text-white text-2xl bg-blue-700 rounded-md px-4 py-2">
          Register Employee
        </h2>
      </div>

      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8 mt-6"
      >
        {/* User Id*/}
        <div>
          <label className="block text-white mb-1 font-medium">User Id</label>
          <input
            type="text"
            name="user_id"
            value={formData.user_id}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter User Id"
          />
          {errors.user_id && (
            <p className="text-red-500 text-sm mt-1">{errors.user_id}</p>
          )}
        </div>
        <div>
          <label className="block text-white mb-1 font-medium">
            Company Name <span className="text-red-500 text-sm">*</span>
          </label>
          <input
            type="text"
            name="company_name"
            value={formData.company_name}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter User Id"
          />
          {errors.company_name && (
            <p className="text-red-500 text-sm mt-1">{errors.company_name}</p>
          )}
        </div>
        {/* Employee Name */}
        <div>
          <label className="block text-white mb-1 font-medium">
            Employee Name <span className="text-red-500 text-sm">*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter Employee Name"
          />
          {errors.name && (
            <p className="text-red-500 text-sm mt-1">{errors.name}</p>
          )}
        </div>

        {/* Email Address */}
        <div>
          <label className="block text-white mb-1 font-medium">
            Email Address <span className="text-red-500 text-sm">*</span>
          </label>
          <input
            type="email"
            name="email_address"
            value={formData.email_address}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter Email"
          />
          {errors.email_address && (
            <p className="text-red-500 text-sm mt-1">{errors.email_address}</p>
          )}
        </div>

        {/* Mobile Number */}
        <div>
          <label className="block text-white mb-1 font-medium">
            Mobile Number <span className="text-red-500 text-sm">*</span>
          </label>
          <input
            type="text"
            name="mobile_number"
            value={formData.mobile_number}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter Mobile"
            maxLength="10"
          />
          {errors.mobile_number && (
            <p className="text-red-500 text-sm mt-1">{errors.mobile_number}</p>
          )}
        </div>

        {/* Password */}
        <div>
          <label className="block text-white mb-1 font-medium">
            Password <span className="text-red-500 text-sm">*</span>
          </label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Min 6 characters"
          />
          {errors.password && (
            <p className="text-red-500 text-sm mt-1">{errors.password}</p>
          )}
        </div>

        {/* PIN */}
        <div>
          <label className="block text-white mb-1 font-medium">PIN</label>
          <input
            type="text"
            name="pin"
            value={formData.pin}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="6 digits"
            maxLength="6"
          />
          {errors.pin && (
            <p className="text-red-500 text-sm mt-1">{errors.pin}</p>
          )}
        </div>

        {/* PIN Code */}
        <div>
          <label className="block text-white mb-1 font-medium">PIN Code</label>
          <input
            type="text"
            name="pin_code"
            value={formData.pin_code}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter PIN Code"
            maxLength="6"
          />
        </div>

        {/* Landmark Address */}
        <div>
          <label className="block text-white mb-1 font-medium">
            Landmark Address
          </label>
          <input
            type="text"
            name="landmark_address"
            value={formData.landmark_address}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter Landmark"
          />
        </div>

        {/* Post Office */}
        <div>
          <label className="block text-white mb-1 font-medium">
            Post Office
          </label>
          <input
            type="text"
            name="post_office"
            value={formData.post_office}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter Post Office"
          />
        </div>

        {/* District */}
        <div>
          <label className="block text-white mb-1 font-medium">District</label>
          <input
            type="text"
            name="district"
            value={formData.district}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter District"
          />
        </div>

        {/* State */}
        <div>
          <label className="block text-white mb-1 font-medium">State</label>
          <input
            type="text"
            name="state"
            value={formData.state}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter State"
          />
        </div>

        {/* Date of Birth */}
        <div>
          <label className="block text-white mb-1 font-medium">
            Date of Birth
          </label>
          <input
            type="date"
            name="dob"
            value={formData.dob}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            max={new Date().toISOString().split("T")[0]}
          />
        </div>

        {/* Aadhar Number */}
        <div>
          <label className="block text-white mb-1 font-medium">
            Aadhar Number
          </label>
          <input
            type="text"
            name="aadhar_number"
            value={formData.aadhar_number}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="12 digits"
            maxLength="12"
          />
          {errors.aadhar_number && (
            <p className="text-red-500 text-sm mt-1">{errors.aadhar_number}</p>
          )}
        </div>

        {/* PAN Number */}
        <div>
          <label className="block text-white mb-1 font-medium">
            PAN Number
          </label>
          <input
            type="text"
            name="pan_number"
            value={formData.pan_number}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="ABCDE1234F"
            maxLength="10"
            style={{ textTransform: "uppercase" }}
          />
          {errors.pan_number && (
            <p className="text-red-500 text-sm mt-1">{errors.pan_number}</p>
          )}
        </div>
      </form>

      {/* Submit Button */}
      <div className="flex justify-center mb-8">
        <button
          type="submit"
          onClick={handleSubmit}
          disabled={loading}
          className="px-6 py-2 bg-blue-600 text-white rounded border border-white hover:bg-blue-700 transition disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow-lg"
        >
          {loading ? "Registering..." : "Register Employee"}
        </button>
      </div>

      {/* user data after successfully creation */}

      {userData && (
        <div className="w-full flex justify-center mb-8">
          <div
            className="w-full md:w-[70%] xl:w-[50%]
                 bg-gradient-to-br from-green-50 to-emerald-50
                 border border-green-100 rounded-2xl shadow-lg
                 hover:shadow-2xl transition-all duration-300
                 px-8 py-6"
          >
            {/* Header */}
            <div className="flex items-center gap-4 text-2xl font-bold text-emerald-700 mb-6">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-emerald-100">
                <User2Icon className="w-6 h-6" />
              </div>
              User Registered Successfully!
            </div>

            {/* Info Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4 text-sm text-gray-700">
              <InfoRow label="User ID">
                {userData?.user?.user_id || userData?.data?.user?.user_id}
              </InfoRow>

              <InfoRow label="Name">
                {userData?.user?.name || userData?.data?.user?.name}
              </InfoRow>

              <InfoRow label="Company Name">
                {userData?.user?.company_name ||
                  userData?.data?.user?.company_name ||
                  "N/A"}
              </InfoRow>

              <InfoRow label="Mobile">
                {userData?.user?.mobile_number ||
                  userData?.data?.user?.mobile_number}
              </InfoRow>

              <InfoRow label="Email">
                {userData?.user?.email_address ||
                  userData?.data?.user?.email_address}
              </InfoRow>

              <InfoRow label="Password">
                {userData?.password || userData?.data?.password}
              </InfoRow>

              <InfoRow label="PIN">
                {userData?.pin || userData?.data?.pin}
              </InfoRow>
            </div>
          </div>
        </div>
      )}

      {/* Permission Selection */}
      {/* <div className="flex justify-center mb-4">
        <h3 className="text-white text-xl bg-blue-600 rounded-md px-4 py-2">
          Assign Permissions{" "}
          {selectedPermissions.length > 0 &&
            `(${selectedPermissions.length} selected)`}
        </h3>
      </div>

      <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
        {Object.keys(allAdminRoutes).map((menu) => (
          <motion.div
            key={menu}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className={`p-3 rounded-lg shadow-md flex flex-col items-center cursor-pointer transition-all ${
              selectedPermissions.includes(menu)
                ? "bg-blue-100 border-2 border-blue-600"
                : "bg-gray-100 border-2 border-transparent"
            }`}
            onClick={() => handlePermissionChange(menu)}
          >
            <input
              type="checkbox"
              checked={selectedPermissions.includes(menu)}
              onChange={() => handlePermissionChange(menu)}
              className="mb-2 w-4 h-4 cursor-pointer"
              onClick={(e) => e.stopPropagation()}
            />
            <span className="font-semibold text-gray-700 text-center text-xs leading-tight">
              {menu}
            </span>
          </motion.div>
        ))}
      </div> */}

      {/* grouped permission */}

      <div className="w-full flex flex-col items-center">
        <div className="flex justify-center mb-4">
          <h3 className="text-white text-xl bg-blue-600 rounded-md px-4 py-2">
            Assign Permissions{" "}
            {selectedPermissions.length > 0 &&
              `(${selectedPermissions.length} selected)`}
          </h3>
        </div>

        <div className="my-4 gap-3 w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {group
            ?.filter((filteredItem) => filteredItem.name)
            .map((item, i) => {
              // 1. Single Action Item (Standalone Card)
              return (
                <label
                  key={item.id || i}
                  className="relative flex items-center justify-between p-4 bg-slate-200/40 border border-slate-800 rounded-2xl cursor-pointer transition-all duration-200 hover:border-blue-500/50 hover:bg-green-600 group"
                >
                  <div className="flex flex-col">
                    <span className="text-sm font-semibold text-slate-100 group-hover:text-white transition-colors">
                      {item.name}
                    </span>
                    <span className="text-xs text-slate-200">
                      Enable this feature
                    </span>
                  </div>

                  <input
                    onChange={() => handlePermissionChange(item?.routePath)}
                    type="checkbox"
                    className=" h-5 w-5 cursor-pointer  rounded-lg border border-slate-300  checked:border-blue-600 transition-all"
                  />
                </label>
              );
            })}
        </div>

        <div className=" grid grid-cols-1 gap-3 mt-4">
          {group
            ?.filter((item) => !item.name)
            .map((newItem, i) => {
              // 2. Submenu Group (The Grid Layout)
              const categoryName = Object.keys(newItem)[0];
              const subMenu = newItem[categoryName]?.subMenu;

              return (
                <div
                  className="space-y-4 border border-gray-400 p-6 rounded-xl"
                  key={i}
                >
                  <div className="flex justify-between items-center gap-4">
                    <h3 className="text-sm font-bold text-slate-400 uppercase tracking-[0.15em]">
                      {categoryName}
                    </h3>
                    <button
                      onClick={() => handleGroupPermisssionChange(subMenu)}
                      className={`bg-gray-200 rounded-full border-2 border-blue-700 w-[50px] h-[30px] flex items-center justify-start `}
                    >
                      <div
                        className={`h-[23px] w-[23px] duration-150 transition ml-[2px]  rounded-full ${
                          subMenu?.every((item) =>
                            selectedPermissions?.includes(item.routePath),
                          )
                            ? "translate-x-[18px] bg-blue-700"
                            : "bg-gray-700"
                        }`}
                      ></div>
                    </button>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
                    {subMenu?.map((sub, idx) => (
                      <label
                        key={sub.id || idx}
                        className="group relative flex items-center gap-3 p-3 rounded-xl border border-slate-200 bg-white hover:border-blue-500 hover:shadow-lg hover:shadow-blue-500/5 transition-all duration-200 cursor-pointer"
                      >
                        <div className="relative flex items-center justify-center">
                          <input
                            onChange={() =>
                              handlePermissionChange(sub?.routePath)
                            }
                            type="checkbox"
                            checked={selectedPermissions?.includes(
                              sub?.routePath,
                            )}
                            className=" h-5 w-5 cursor-pointer  rounded-lg border border-slate-300  checked:border-blue-600 transition-all"
                          />
                        </div>

                        <span className="text-sm font-medium text-slate-700 group-hover:text-slate-900">
                          {sub.name}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </motion.div>
  );
}

export default RegEmployee;

const InfoRow = ({ label, children }) => (
  <div className="flex items-center justify-between gap-4">
    <span className="font-semibold text-gray-600">{label}</span>
    <span className={`font-medium text-right break-all `}>{children}</span>
  </div>
);
